import { calculatorRegistry } from '@/lib/constants/calculators';

/**
 * Generates a properly formatted calculator URL for the given country
 * Validates calculator availability and returns appropriate fallback
 */
export function getCalculatorUrl(slug: string, countryCode: string): string {
  const calc = calculatorRegistry.find(c => c.slug === slug);
  
  if (!calc) {
    // Calculator doesn't exist, return country homepage
    return `/${countryCode}`;
  }
  
  // Check if calculator supports this country
  const isSupported = calc.countries === 'all' || calc.countries.includes(countryCode);
  
  if (!isSupported) {
    // Calculator doesn't support this country
    // Return the first supported country's version
    if (calc.countries !== 'all' && calc.countries.length > 0) {
      const firstSupportedCountry = calc.countries[0];
      return `/${firstSupportedCountry}/${calc.category}/${slug}`;
    }
    // Fallback to country homepage
    return `/${countryCode}`;
  }
  
  // Calculator supports this country, return proper URL
  return `/${countryCode}/${calc.category}/${slug}`;
}

/**
 * Extracts calculator slug from various URL formats
 * Handles: "/us/tax/no-tax-on-tips", "no-tax-on-tips", "tax/no-tax-on-tips"
 */
export function extractCalculatorSlug(href: string): string {
  const parts = href.split('/').filter(Boolean);
  // Return the last part which should be the slug
  return parts[parts.length - 1] || '';
}

/**
 * Gets the active country code from pathname or defaults to 'us'
 */
export function getActiveCountry(pathname: string): string {
  const pathParts = pathname.split('/').filter(Boolean);
  const validCountries = ['us', 'gb', 'au', 'ca', 'in', 'sg', 'nz', 'de', 'ch', 'nl'];
  
  if (pathParts.length > 0 && validCountries.includes(pathParts[0])) {
    return pathParts[0];
  }
  
  return 'us'; // Default fallback
}
